import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { ToastAlertSliceType } from './types';

const initialState: ToastAlertSliceType = {
  status: 'success',
  message: '',
};

const toastAlertSlice = createAppSlice({
  name: 'toastAlert',
  initialState,
  reducers: {
    /**
     * One toast at a time — a new toast replaces the current one, EXCEPT that a
     * success never replaces an error that is still on screen (PI-12153). The
     * slice is cleared the moment a toast starts dismissing
     * (`GlobalToastAlert`), so "message present" means "still showing".
     */
    setToastAlert(state, action: PayloadAction<ToastAlertSliceType>) {
      const isErrorShowing = Boolean(state.message) && state.status === 'error';
      const isBlocked = isErrorShowing && action.payload.status === 'success';
      return isBlocked ? state : action.payload;
    },
    resetToastAlert() {
      return initialState;
    },
  },
});

export const { setToastAlert, resetToastAlert } = toastAlertSlice.actions;
export default toastAlertSlice.reducer;
